export default "__VITE_ASSET__DsLo5CW8__"